import { Injector } from "@angular/core";
import { AuthService } from "../../service/auth-service/auth-service.service";
import { LocalStorageUtil } from "../LocalStorageUtil";
import { SimpleSearchNode } from "./SimpleSearchNode";
import { Art57Section } from "../Art57Section/Art57Section";
import { environment } from "../../../../environments/environment";
import { BaseNode } from "./BaseNode";
import { SectionService } from "../../service/section-service/section-service";
import { OnDemandAutoUploadNode } from "./MedicinalProductsNode/OnDemandAutoUploadNode";

export class SimpleSearchListNode extends SimpleSearchNode {

    historyItems:string[]=[];
    criteria:string="";
    showResults:boolean=false;

    constructor(injector: Injector, view: any, labelTemplate: string, entity: string) {

        super(injector, view, labelTemplate, entity);

        let localStorageKey: string = `${injector.get(AuthService).getUser()}_${injector.get(AuthService).getOrganisation()}_${this.entityName}`;
        this.historyItems = LocalStorageUtil.getLocalStorageJson(localStorageKey); 

    }

    addChildNode(entityClass: new (...args: any[]) => any, labelTemplate: string,parent: any, model: any, useHist:boolean, disableAutoUpload: boolean, cloningNode: boolean): BaseNode|undefined{
        const alreadyExistChildren = this.children?.find((child: any) => child.code === model.id);
        if (!alreadyExistChildren) {
            const newChild = new entityClass(this.ioc!, labelTemplate, parent, model, useHist, disableAutoUpload, cloningNode);
            this.children?.push(newChild);
            return newChild;
        } else {
            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: `Item already selected: ${labelTemplate}`, life: environment.warningElapsedTime });
            return alreadyExistChildren as BaseNode;
        }        
    }
    
    addChild(model: any): BaseNode|undefined{
        return undefined;
    }

    removeChild(childKeyToRemove: string) {
        this.children = this.children!.filter((child) => child.key !== childKeyToRemove);
    }

    getCriteriaFields(): string[] {
        return [];
    }

    /**
     * 
     * @param checkedEntities List of entities to be added as children to the current node 
     * @param ignoreNewChildren Whether to ignore newly added children when repositioning the tree, remove recursivity in multiple calls by Treenode UI Design
     */
    loadEntityNode(checkedEntities: any, ignoreNewChildren: boolean = false){
        let newChild: BaseNode|undefined = undefined;
        checkedEntities.forEach((item: any) => {
            let lastAddedChildren = this.addChild(item);
            if (newChild == undefined) { // set newChild to first children
               newChild = lastAddedChildren;     
            }
          });
          this.refreshLabel();
          if (!ignoreNewChildren && newChild){ // reposition tree in the first children
             this.ioc!.get(SectionService).selectMedicinalProductsNode(newChild!);
          }
    }

    getPlaceHolderTemplate(): string{
        return "Search...";
    }

    getPlaceHolderToolTipTemplate(): string{
        return this.getPlaceHolderTemplate() + " (Type any character and press [ENTER] to execute the search)";
    }

    override refreshLabel(): void {
        this.label = this.parent instanceof OnDemandAutoUploadNode ? `${this.labelTemplate} (${this.children?.length ?? 0})` : this.labelTemplate;
    }


}